import axios from '@/axios.js'
import state from '../../state'

export default ({
  isRegistered: false,
  namespaced: true,
  state: {
    operacion: [],
    operaciones: [],
    operacionesProductos: [],
    operacionesAnuales: [],
    crearDecisor: null,
    altaOperacion: false  // Para saber se estamos dando de alta unha operación (true) e ao gardar envialo a editar operación na solapa de productos
  },
  actions: {
    getOperacion ({commit}, operacionId) {
      return new Promise((resolve, reject) => {
        axios.get(`/api/operacions/${operacionId}`)
          .then((response) => {
            commit('setOperacionMutation', response.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    getOperaciones ({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios.get(`/api/lista_operacions/${JSON.stringify(params)}`)
          .then((response) => {
            if (params.consulta === 'operaciones') {
              commit('setOperacionesMutation', response.data)
            } else if (params.consulta === 'operacionesProductos') {
              commit('setOperacionesProductosMutation', response.data)
            } else if (params.consulta === 'operacionesAnuales') {
              commit('setOperacionesAnualesMutation', response.data)
            }
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    addOperacion ({ commit }, operacion) {
      return new Promise((resolve, reject) => {
        axios.post('/api/operacions', operacion)
          .then((response) => {
            commit('addOperacionMutation', response)
            resolve(response)
          })
          .catch((error) => { 
            reject(error) 
          })
      })
    },
    addOperacionPersona (context, operacionPersona) {
      return new Promise((resolve, reject) => {
        axios.post('/api/operacion_personas', operacionPersona)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => { 
            reject(error) 
          })
      })
    },
    updateOperacionProductos ({ commit }, productos) {
      commit('updateOperacionProductosMutation', productos)
      return productos
    },
    updateOperacion ({ commit }, operacion) {    
      return new Promise((resolve, reject) => {        
        axios.patch(`/api/operacions/${operacion.id}`, operacion, { headers: {'Content-Type': 'application/merge-patch+json'} })
          .then((response) => {
            commit('updateOperacionMutation', response.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    updateOperacionPersona ({ commit }, operacionPersona) {
      return new Promise((resolve, reject) => {
        axios.patch(`/api/operacion_personas/${operacionPersona.id}`, operacionPersona, { headers: {'Content-Type': 'application/merge-patch+json'} })
          .then((response) => {
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    /**
     * Cada vez que se fai unha modificación nas solapas 'Productos', 'Detalle de productos' ou 'Documentación' da operación hai que lanzar esta función
     */
    actualizarPorcentajeCompletado ({commit}, operacion) {
      return new Promise((resolve, reject) => {
        axios.get(`/api/actualizar_porcentaje_completado/${operacion}`)
          .then((response) => {
            resolve(response)
          }) 
          .catch((error) => {
            reject(error)
          })
      })
    },
    crearDecisor ({commit}, valor) {
      commit('crearDecisorMutation', valor)
    },
    altaOperacion ({commit}, valor) {
      commit('altaOperacionMutation', valor)
    },
    emptyOperaciones ({ commit }) {
      commit('emptyOperacionesMutation')
    },
    emptyOperacion ({ commit }) {
      commit('emptyOperacionMutation')
    }
  },
  mutations: {
    setOperacionMutation (state, operacion) {
      state.operacion = operacion
    },
    setOperacionesMutation (state, operaciones) {
      state.operaciones = operaciones
    },
    setOperacionesProductosMutation (state, operacionesProductos) {
      state.operacionesProductos = operacionesProductos
    },
    setOperacionesAnualesMutation (state, operacionesAnuales) {
      state.operacionesAnuales = operacionesAnuales
    },
    addOperacionMutation (state, operacion) {
      state.operaciones.push(operacion)
    },
    updateOperacionProductosMutation (state, productos) {           
      state.operacion.productos = []
      state.operacion.productos = productos
    },
    updateOperacionMutation (state, operacion) {
      state.operacion = operacion // Actualizamos no state a operación
      const idx = state.operaciones.findIndex((u) => u.id === operacion.id) // Buscamos o índice do elemento no array do state
      state.operaciones.splice(idx, 1, operacion)  // Substituimos no array de operacións a operación anterior pola nova
    },
    crearDecisorMutation (state, valor) {
      state.crearDecisor = valor
    },
    altaOperacionMutation (state, valor) {
      state.altaOperacion = valor
    },
    emptyOperacionesMutation (state) {
      // Vaciamos o store
      state.operaciones = []
    },
    emptyOperacionMutation (state) {
      // Vaciamos o store
      state.operacion = []
    }
  },
  modules: {}
})